export default __webpack_public_path__ + "static/media/info-img2.ccbc442b.png";